module.exports = __webpack_public_path__ + "img/style5.8c3c617f.jpg";